export const BLACKLIST_BUILD_PATHS = [
  'blog',
  'case-study',
  'careers',
  'events',
  'articles',
  'testimonials',
  'clients',
  'news',
  'ebooks',
  'livres-numeriques',
  'emplois',
  'carrieres',
  'calendrier-des-evenements-en-assurance',
  'temoignages',
  'nouvelles',
  'blogue',
  'etudes-de-cas',
  'fr/clients',
  'fr/emplois',
  'fr/carrieres',
  'fr/nouvelles',
  'fr/blogue',
  'fr/calendrier-des-evenements-en-assurance',
  'fr/temoignages',
  'fr/etudes-de-cas',
  'fr/livres-numeriques',
];
